import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from "../../http/api";
import { Collection } from "../../http/collection";
import { Store } from "@ngxs/store";
import { Filter, FilterBuilder } from "../../http/filter";
import { Observable } from "rxjs";
import { DetailRequest, DetailRequestBuilder } from "../../http/detail";
import { BaseReportComponent } from "@core/data/types/advanced-report";
import { ReportHttpHelperService } from "./advanced-report-http-helper.service";
import { tap } from "rxjs/operators";

export class ReportComponentDeleted {
    static readonly type = "[ReportComponentService] Component Deleted";
    constructor(public component: BaseReportComponent){}
}

@Injectable()
export class ReportComponentService {

    constructor(
        @Inject(API_BASE_URI) private _baseUri: string,
        private _http: HttpClient,
        private _store: Store,
        private _httpHelperService: ReportHttpHelperService,
    ) {}

    get(key: string, shareKey: string, detail?: DetailRequest): Observable<BaseReportComponent> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<BaseReportComponent>(`${this._baseUri}/report-component/${key}`, this._httpHelperService.withShareKey({params}, shareKey));
    }

    // TODO see if we need to handle create response
    create(model: Partial<BaseReportComponent>): Observable<BaseReportComponent> {
        return this._http.post<BaseReportComponent>(`${this._baseUri}/report-component`, model);
    }

    // TODO LOOK INTO ONLY HANDELING THE STATUS, OR HOW RESPONSE SHOULD BE HANDLED
    update(key: string, model: Partial<BaseReportComponent>): Observable<BaseReportComponent>{
        return this._http.put<BaseReportComponent>(`${this._baseUri}/report-component/${key}`, model);
    }

    delete(key: string, showMessage: boolean) {
        return this._http.delete<BaseReportComponent>(`${this._baseUri}/report-component/${key}`)
            .pipe(
                tap(result => {
                    if (!showMessage) return;

                    this._store.dispatch(new ReportComponentDeleted(result))
                })
            );
    }

}